/**
 * Special version of the Schedule model:
 * represents the compact view used in the Compact Schedule list
 *
 * This model does not represent a full schedule,
 * it is only used for displaying the compact schedule list.
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import dayjs from 'dayjs';
import { getEventStatusIconColor } from './Event';

export class CompactSchedule extends BaseModel {
    defaults() {
        return {
            // entity properties
            id: null,
            uuid: null,
            event_id: null,
            location_id: null,
            start_date: null,
            end_date: null,
            event_time_start: null,
            event_time_end: null,
            opening_time_start: null,
            opening_time_end: null,
            recurring_type: null,
            created: null,
            modified: null,
            location_title: null,
            location_zip: null,
            location_city: null,
            schedule_status_id: null,
            schedule_status_ident: null,
            schedule_status_value: null,
            is_sold_out: false,

            // view properties
            schedule_location_title: null,
            event_title: null,
            event_status: null,
        };
    }

    get event_status_icon_color() {
        return getEventStatusIconColor(this.event_status);
    }

    get locationTitleWithCity() {
        return [this.location_title || null, this.location_city || null].filter(Boolean).join(', ') || '';
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),

            start_date: dayjs,
            end_date: dayjs,

            created: dayjs,
            modified: dayjs,
            is_sold_out: Boolean,
        };
    }

    entityName() {
        return 'CompactSchedule';
    }
}

export class CompactScheduleCollection extends BaseCollection {
    options() {
        return {
            model: CompactSchedule,
        };
    }

    entityName() {
        return 'CompactSchedule';
    }
}
